import { RSAA } from 'redux-api-middleware'

import { EstateUtils } from '../utils'

export const Types = {
    FETCH_DEVICE_GROUPS_REQUEST: 'FETCH_DEVICE_GROUPS##REQUEST',
    FETCH_DEVICE_GROUPS_SUCCESS: 'FETCH_DEVICE_GROUPS##SUCCESS',
    API_CALL_FAILURE: 'API_CALL##FAILURE',
}

/**
 * Update device info
 */
export const fetchDeviceGroups = () => {
    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/device_groups`,
                method: 'GET',
                types: [Types.FETCH_DEVICE_GROUPS_REQUEST, Types.FETCH_DEVICE_GROUPS_SUCCESS, Types.API_CALL_FAILURE],
            },
        })
    }
}
